import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import ShopInfo from "@/components/ShopInfo";
import styles from "@/styles/article/return-policy.module.scss";
import Link from "next/link";
import { Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";

export default function AffiliateProgram() {
  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div
          className={`${styles["page-return-policy"]}`}
          style={{ minHeight: "680px" }}
        >
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles["content"]}>
            <div className={styles["content-title"]}>Affiliate Program</div>

            <div className={styles["answer-desc"]}>
              Join the &nbsp;
              <Link href="https://www.crazysales.com.au/" legacyBehavior>
                <a className={styles["link"]} rel="noopener noreferrer">
                  CrazySales.com.au
                </a>
              </Link>
              &nbsp;Affiliate Program and let us help you make money!
            </div>
            <div className={styles["answer-desc"]}>
              The CrazySales affiliate program is your opportunity to expand
              your business with one of the fastest growing online shopping
              sites in Australia. With our product range already in the
              thousands, we are constantly increasing our inventory to give
              customers more reasons to shop, and our affiliates even more ways
              to earn money.
            </div>
            <div className={styles["answer-desc"]}>
              Add a hyperlink, icon or banner of ours to your site to start
              earning commission on every new sale referred by your site.
            </div>

            <div className={`${styles["ask-title"]} padding-top-24`}>
              CrazySales offers your customers:
            </div>
            <div className={styles["answer-desc"]}>
              <CheckOutlined
                style={{ color: "#D70B17", marginRight: "8px" }}
              ></CheckOutlined>
              Australia&apos;s Top Online Shopping
            </div>
            <div className={styles["answer-desc"]}>
              <CheckOutlined
                style={{ color: "#D70B17", marginRight: "8px" }}
              ></CheckOutlined>
              Thousands Of Merchandise To Choose From At The Best Prices
            </div>
            <div className={styles["answer-desc"]}>
              <CheckOutlined
                style={{ color: "#D70B17", marginRight: "8px" }}
              ></CheckOutlined>
              Daily Sales and Discounts
            </div>
            <div className={styles["answer-desc"]}>
              <CheckOutlined
                style={{ color: "#D70B17", marginRight: "8px" }}
              ></CheckOutlined>
              Fast Efficient Shipping
            </div>
            <div className={styles["answer-desc"]}>
              <CheckOutlined
                style={{ color: "#D70B17", marginRight: "8px" }}
              ></CheckOutlined>
              Safe and Secure Checkout
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingBottom: "24px",
              }}
            >
              <Button type="primary">
                <a 
                  style={{ color: "#FFFFFF", fontWeight: 700 }}
                  href="https://dashboard.commissionfactory.com/Affiliate/Register/12475/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Join Our Affiliate Program
                </a>
              </Button>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  );
}
